import type { CategoryLevel } from '../enums/CategoryLevel'
import type { CategoryTranslationEntity } from './CategoryTranslationEntity'
import type { BranchEntity } from '@/features/branch/domain/entities/BranchEntity'

export class CategoryEntity {
  id?: number
  imageUrl?: string | null
  children?: Array<CategoryEntity> | null
  parentId?: number | null
  translations?: Array<CategoryTranslationEntity> | null
  level?: CategoryLevel
  enabled?: boolean
  order?: number
  branch?: BranchEntity
  branchName?: string | null
  parentCategory?: CategoryEntity | null
  startTime?: string | null
  endTime?: string | null
  isSensitive?: boolean
  isServiceCategory?: boolean
  zohoBooksCostAccountId?: string | null
  zohoBooksSalesAccountId?: string | null
}
